/**
 * Drawer — volet latéral (desktop) / plein écran (mobile), avec fond assombri.
 * Réutilisé par « Noter un vin » et « À découvrir ». Fermeture par le fond, la croix ou Échap.
 */
import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

export function Drawer({ open, onClose, title, children, footer, testId = 'drawer', width = 'max-w-xl' }) {
  const downOnOverlay = useRef(false);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/40 animate-fade-in"
      onMouseDown={(e) => { downOnOverlay.current = e.target === e.currentTarget; }}
      onClick={(e) => { if (e.target === e.currentTarget && downOnOverlay.current) onClose(); downOnOverlay.current = false; }}
      data-testid={`${testId}-overlay`}>
      <div
        className={`bg-paper h-full w-full ${width} shadow-xl flex flex-col animate-slide-in-right`}
        onClick={(e) => e.stopPropagation()}
        data-testid={testId}
      >
        <div className="flex items-center justify-between px-4 md:px-5 h-14 border-b border-hair shrink-0">
          <h2 className="font-title text-2xl truncate">{title}</h2>
          <button onClick={onClose} data-testid={`${testId}-close`} className="p-2 -mr-2 text-n600 hover:text-ink"><X className="w-5 h-5" strokeWidth={1.6} /></button>
        </div>
        <div className="flex-1 overflow-auto px-4 md:px-5 pt-4 pb-28 md:pb-4">{children}</div>
        {footer && <div className="border-t border-hair px-4 md:px-5 py-3 shrink-0 bg-surface/50">{footer}</div>}
      </div>
    </div>
  );
}
